export const NotFoundPageTranslationsCs = {
  'Page not found': 'Stránka nenalezena',
  'Problem explanation':
    'Omlouváme se, ale stránka, kterou hledáte, nebyla nalezena. Zkuste to prosím znovu.',
  Homepage: 'Domovská stránka',
};
